module.exports = __webpack_public_path__ + "static/media/ao.21c174a3.webp";